/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vereinbarungurheberrechterhalten2Inputs */

const de__field_vereinbarungurheberrechterhalten2 = /** @type {(inputs: _Field_Vereinbarungurheberrechterhalten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbarung Urheberrecht erhalten`)
};

/**

* @param {_Field_Vereinbarungurheberrechterhalten2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vereinbarungurheberrechterhalten2 = /** @type {((inputs?: _Field_Vereinbarungurheberrechterhalten2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vereinbarungurheberrechterhalten2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_vereinbarungurheberrechterhalten2(inputs)
});
export { _field_vereinbarungurheberrechterhalten2 as "_field_vereinbarungUrheberrechtErhalten" }